import { render, staticRenderFns } from "./CouponsTable.vue?vue&type=template&id=79d30672&scoped=true"
import script from "./CouponsTable.vue?vue&type=script&lang=js"
export * from "./CouponsTable.vue?vue&type=script&lang=js"
import style0 from "./CouponsTable.vue?vue&type=style&index=0&id=79d30672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d30672",
  null
  
)

export default component.exports